import { render, staticRenderFns } from "./VaDrugReportPage.vue?vue&type=template&id=009b1de2&"
import script from "./VaDrugReportPage.vue?vue&type=script&lang=js&"
export * from "./VaDrugReportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports